import { graphql } from "gatsby";
import React from "react";
import SectionStandardSignPostCards from "../../../containers/sections/SectionStandardSignPostCards";
import { mapContentUnionToSignPostCardProps } from "../../../utils/mappers";

export interface ParagraphSupportCardsProps {
	heading?: string;
	jumpLinksTitle?: string;
	htmlText?: string;
	items: DogsTrust.SignPostCardProps[];
}

export const getParagraphSupportCardsProps = ({
	field_heading,
	field_jump_links_title,
	field_text,
	relationships: { field_content },
}: Queries.ParagraphSupportCardsDataFragment): ParagraphSupportCardsProps => ({
	heading: field_heading,
	jumpLinksTitle: field_jump_links_title,
	htmlText: field_text?.value,
	items: field_content.map(mapContentUnionToSignPostCardProps),
});
export const ParagraphSupportCards: React.FC<ParagraphSupportCardsProps> = ({
	heading,
	jumpLinksTitle,
	htmlText,
	items,
}) => {
	return (
		<SectionStandardSignPostCards
			items={items}
			title={heading}
			bodyHtmlText={htmlText}
			withPageBreak={false}
			withoutMargins={true}
			forceFlatCards={false}
			jumpLinksTitle={jumpLinksTitle}
		/>
	);
};

export default ParagraphSupportCards;

export const fragment = graphql`
    fragment ParagraphSupportCardsData on paragraph__support_cards {
        __typename
        id
        field_heading
		field_jump_links_title
        field_text {
            value
        }
        relationships {
            field_content {
                ...ContentUnionData
            }
        }
    }
`;
